import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgFilter(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6a1 1 0 0 0 0 2h16a1 1 0 1 0 0-2H4Zm5 5a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2H9Zm2 5a1 1 0 1 0 0 2h2a1 1 0 1 0 0-2h-2Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgFilter)
